import { Toolbar, Box, Typography } from "@mui/material";
import LocationIcon from "@mui/icons-material/LocationOn";

import { useEstateSelection } from "@/modules/estate/hooks/useEstateSelection";
import { fullAddress } from "../functions/users";

function CurrentEstateToolbar() {
  const { currentEstate } = useEstateSelection();
  const address = currentEstate ? fullAddress(currentEstate.address) : "";

  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
        <LocationIcon sx={{ mr: 1.8, ml: 1 }} />
        <Typography>{address}</Typography>
      </Box>
    </Toolbar>
  );
}

export default CurrentEstateToolbar;
